module.exports = __webpack_public_path__ + "static/media/1.c9c7c0eb.jpg";